import axios from 'axios';
import { Cacheable } from './cache';
import { API_BASE_URL } from './contests';

export type ParticipantEntry = {
  contest_id: number;
  contest_name: string;
  result: number | null;
  result_unit: string | null;
  grouping: string | null;
  ranking?: number;
  total_participants: number | null;
  created_at: string | null;
  participant_data: string | null;
  participant_name: string | null;
  profile_picture: string | null;
  participant_id: number;
  evidence_url: string | null;
};

export const fetchParticipantEntries = Cacheable('participantEntries_fetchParticipantEntries')(async (participantId: string): Promise<ParticipantEntry[]> => {
  const response = await axios.get(`${API_BASE_URL}/participant-entries/${participantId}`);
  return Array.isArray(response.data) ? response.data : [];
});
